<template>
    <v-card tile class="pa-0" hover height="100%">
        <v-card-text class="text-center">
            <h5 class="teal-color text-center mb-2">{{ title }}</h5>
            <div class="text-center pb-2">
                <v-progress-circular :rotate="360" :size="size" :width="width" :value="value" :color="color">
                    <b color="teal">{{ value }} % </b>
                </v-progress-circular>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        props: ['title', 'size', 'width', 'color', 'value'],
    }
</script>

<style scoped>
</style>